import { pick as _pick, isEmpty as _isEmpty } from "lodash-es";
import { useEffect } from "react";
import { useStore } from "react-redux";
import { deletedObjectsCommit, setPending, setSaved } from "../actions/sync";
import { axiosClient } from "../redux_axios_middleware";
import { SYNC_PUSH_DATA_CONFIG } from "../syncConfig";

function getObjectsToSave(objects, fields) {
  const data = {};
  for (let i of objects) {
    if (i.modified && !i.pending && !i.conflict) {
      data[i.id] = _pick(i, fields);
    }
  }
  return data;
}

async function pushUpdates(store) {
  const state = store.getState();

  const currentDeletedObjects = state.deletedObjects;

  const data = {};
  for (const k in SYNC_PUSH_DATA_CONFIG) {
    const [backendKey, fields] = SYNC_PUSH_DATA_CONFIG[k];
    data[backendKey] = getObjectsToSave(state[k], fields);
  }

  const hasDeletedObjects = Object.keys(currentDeletedObjects).some(
    (k) => currentDeletedObjects[k].length > 0
  );
  const hasModifiedObjects = Object.keys(data).some((k) => !_isEmpty(data[k]));
  const hasDataToPush = hasDeletedObjects || hasModifiedObjects;
  if (!hasDataToPush) return;

  data.__deleted = currentDeletedObjects;

  hasDataToPush && store.dispatch(setPending(data, true));

  let response;

  try {
    response = await axiosClient({
      method: "POST",
      url: "updates.json",
      data: data,
      timeout: 30 * 1000,
    });
  } catch (e) {
    console.log(e);
    hasDataToPush && store.dispatch(setPending(data, false));
    return;
  }

  try {
    hasDeletedObjects &&
      store.dispatch(deletedObjectsCommit(currentDeletedObjects));

    hasDataToPush && store.dispatch(setSaved(response.data));
  } catch (e) {
    console.error(e);
    hasDataToPush && store.dispatch(setPending(data, false));
  }
}

const SyncPushService = () => {
  const store = useStore();

  useEffect(() => {
    let timeoutId = { id: null };

    const schedule = (t) => {
      timeoutId.id = setTimeout(async () => {
        try {
          await pushUpdates(store);
        } catch (e) {
          console.error(e);
        }
        schedule(5000);
      }, t);
    };

    schedule(1);

    return () => {
      clearTimeout(timeoutId.id);
    };
  }, [store]);

  return null;
};

export default SyncPushService;
